Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var alignmentProps = ['top', 'middle', 'bottom'];

var topMiddleOrBottom = (0, _airbnbPropTypes.and)([_airbnbPropTypes.booleanSome.apply(undefined, alignmentProps), _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(undefined, alignmentProps)]);

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node.isRequired,
  top: topMiddleOrBottom,
  middle: topMiddleOrBottom,
  bottom: topMiddleOrBottom
}));

var defaultProps = {
  top: false,
  middle: false,
  bottom: false
};

function VerticalAlign(_ref) {
  var css = _ref.css,
      children = _ref.children,
      styles = _ref.styles,
      top = _ref.top,
      middle = _ref.middle,
      bottom = _ref.bottom;

  return _react2['default'].createElement(
    'div',
    css(styles.container, top && styles.top, middle && styles.middle, bottom && styles.bottom),
    children
  );
}

VerticalAlign.componentCategory = 'Core';
VerticalAlign.displayName = 'VerticalAlign';
VerticalAlign.propTypes = propTypes;
VerticalAlign.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    container: {
      display: 'table-cell'
    },

    top: {
      verticalAlign: 'top'
    },

    middle: {
      verticalAlign: 'middle'
    },

    bottom: {
      verticalAlign: 'bottom'
    }
  };
})(VerticalAlign);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/VerticalAlignmentContainer/VerticalAlign.js
// module id = 146
// module chunks = 923280921217 213534597649335